<template>
  <GlobalLoading />
  <a-config-provider size="mini">
    <AppProvider>
      <router-view />
      <!-- <global-setting /> -->
    </AppProvider>
  </a-config-provider>
  <ReloadElectronPrompt v-if="isElectron" />
  <reload-prompt v-else />
</template>

<script lang="ts" setup>
  // import { computed } from 'vue';
  // import enUS from '@arco-design/web-vue/es/locale/lang/en-us';
  // import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn';
  // import GlobalSetting from '@/components/global-setting/index.vue';
  // import useLocale from '@/hooks/locale';
  import AppProvider from '@/components/provider/index.vue';
  import GlobalLoading from '@/components/globalLoading.vue';
  import ReloadPrompt from '@/components/reloadPrompt.vue';
  import ReloadElectronPrompt from '@/components/reloadElectronPrompt.vue';
  // import { watch } from 'vue';
  // import pinia from '@/store';
  import { useTabBarSync, isElectronMainPage } from '@/utils/electronHelper';
  import { h, ref } from 'vue';
  import { Modal } from '@arco-design/web-vue';

  // ag-grid 报错兼容
  let agGridTableError = false;
  try {
    document.querySelector(':not(title, meta)');
  } catch (err: any) {
    if (
      err &&
      err.message ===
        "Failed to execute 'querySelector' on 'Document': ':not(title, meta)' is not a valid selector."
    ) {
      agGridTableError = true;
    }
  }
  // 检测浏览器版本是否过低
  function checkBrowserVersion(): boolean {
    const ua = navigator.userAgent;
    // 最低版本要求
    const minVersions: Record<string, number> = {
      Chrome: 120,
      Edge: 120,
      Firefox: 114,
      Safari: 16.4,
    };

    let browserName = '';
    let browserVersion = 0;

    // 检测 Edge (Chromium版)
    if (ua.includes('Edg/')) {
      browserName = 'Edge';
      const match = ua.match(/Edg\/(\d+)/);
      if (match) browserVersion = parseInt(match[1], 10);
    }
    // 检测 Chrome
    else if (ua.includes('Chrome/') && !ua.includes('Edg')) {
      browserName = 'Chrome';
      const match = ua.match(/Chrome\/(\d+)/);
      if (match) browserVersion = parseInt(match[1], 10);
    }
    // 检测 Firefox
    else if (ua.includes('Firefox/')) {
      browserName = 'Firefox';
      const match = ua.match(/Firefox\/(\d+)/);
      if (match) browserVersion = parseInt(match[1], 10);
    }
    // 检测 Safari
    else if (ua.includes('Safari/') && ua.includes('Version/')) {
      browserName = 'Safari';
      const match = ua.match(/Version\/(\d+)/);
      if (match) browserVersion = parseInt(match[1], 10);
    }

    // 检查版本是否低于最低要求
    if (browserName && minVersions[browserName] !== undefined) {
      return browserVersion < minVersions[browserName];
    }

    return false;
  }

  // 如果浏览器版本过低，显示升级提示
  if (checkBrowserVersion() || agGridTableError) {
    const browsers = [
      {
        name: '微软Edge浏览器(win10+)',
        url: 'https://www.microsoft.com/edge',
      },
      { name: '360浏览器（win7+）', url: 'https://browser.360.cn/' },
      { name: '谷歌浏览器（win10+）', url: 'https://www.google.cn/chrome/' },
      {
        name: '火狐浏览器（win10+）',
        url: 'https://www.mozilla.org/firefox/new/',
      },
    ];

    const ModalContent = {
      setup() {
        return () =>
          h('div', { class: 'info-modal-content' }, [
            h('p', '推荐下载以下最新版浏览器：'),
            h(
              'ul',
              { style: 'padding-left: 20px;' },
              browsers.map((browser) => {
                return h('li', {}, [
                  h(
                    'a',
                    {
                      href: browser.url,
                      target: '_blank',
                      style: 'color: #165DFF;',
                    },
                    browser.name
                  ),
                ]);
              })
            ),
          ]);
      },
    };

    Modal.info({
      title: '您的浏览器版本过低，请升级或切换浏览器以获得更好的体验。',
      content: () => h(ModalContent),
      okText: '我知道了',
      maskClosable: false,
    });
  }

  useTabBarSync();

  const isElectron = ref(isElectronMainPage());

  // const { currentLocale } = useLocale();
  // const locale = computed(() => {
  //   switch (currentLocale.value) {
  //     case 'zh-CN':
  //       return zhCN;
  //     case 'en-US':
  //       return enUS;
  //     default:
  //       return enUS;
  //   }
  // });
</script>
